<template>
  <v-btn fab dark small color="amber darken-2" slot="activator" @click="template()">
    <v-icon>subject</v-icon>
  </v-btn>
</template>

<script>
export default {
  methods: {
    template() {
      this.$emit("template");
    }
  }
};
</script>

<style>
</style>
